<template>
  <div class="h3">
    <div v-show="$route.name == 'COMPLETE'">
      <p>
        Nesse exercício você terá que escolher uma entre três opções que completam a sentença.
      </p>
      <p>
        Após a escolha é apresentado o texto integral da assertiva, com a resposta correta e a sua respectiva origem.
      </p>
      <p>
        Os exercícios do complete foram elaborados a partir de textos legais, súmulas ou assertivas aplicadas nos concursos públicos.
      </p>
      <p><strong>
          Objetivo: aprender os artigos de lei necessários para responder corretamente as questões do módulo.
        </strong></p>
    </div>
    <div v-show="$route.name == 'ASSERTIVAS'">
      <p>
        Nesse exercício você responderá ciclos de questões do tipo verdadeiro/falso,
        que foram elaborados com assertivas extraídas de questões aplicadas em
        provas oficiais sobre assuntos que compõem o módulo em estudo.
      </p>
      <p>
        Imediatamente após você assinalar sua resposta, o SAT-ACS apresentará a resposta correta e as fundamentaçóes legais e doutrinárias.
      </p>
      <p><strong>
          Objetivo: preparar o aluno para a resolução das questões objetivas.
        </strong></p>
    </div>
    <div v-show="$route.name == 'QUESTOES'">
      <p>
        Nesse exercício você responderá ciclos de questões aplicadas em provas oficiais.
      </p>
      <p>
        Os exercícios versarão sobre assuntos pertinentes ao bloco em estudo, após selecionar uma resposta o sistema fará a correção e apresentará na tela o dispositivo legal (artigo) que confirma a resposta correta e sua respectiva fundamentação doutrinária.
      </p>
      <p><strong>
          Objetivo: aferir e reforçar os conhecimentos obtidos com os exercícios anteriores.
        </strong></p>
    </div>
  </div>
</template>

<script>
var componentData = {
}
var componentDefinition = {
  created: function () {
  },
  mounted: function () {
  },
  data: function () {
    return componentData
  }
}
export default componentDefinition
</script>
